import {
  Box,
  Button,
  Dialog,
  DialogProps,
  FormControl,
  FormControlLabel,
  MenuItem,
  OutlinedInput,
  RadioGroup,
  Select,
  SelectChangeEvent,
  Theme,
  useTheme,
} from "@mui/material";
import React, { ChangeEvent, useCallback, useState } from "react";
import Radio from "@mui/material/Radio";
// import styles from "@/styles/components/filterModal.module.scss";
import styles from "../../styles/layout/modal/confirmsectionmodal.module.scss";
import assest from "../../json/assest";
import { useAppDispatch } from "../../hooks/useAppDispatch";
// import {
//   setHasNote,
//   setUnreachableSubmitter,
//   setHasMessage,
//   setMonth,
//   setYear,
//   setSubmitPlace,
//   setUserId,
//   setManagerId,
//   setQualityTeamId,
//   setPeopleAppearing,
//   setPersonWhoFilmed,
//   setSubmitOtherWebsite,
//   setAgreementWithAnotherCompany,
// } from "../../redux-toolkit/slices/dashboard.approve.approve.slice";
import { useAppSelector } from "../../hooks/useAppSelector";
import {
  countryData,
  sampleMonthsValueArray,
  sampleYearList,
  truncateString,
} from "../../lib/functions/utils.lib";
import countries from "countries-list";
// import assest from "@/json/assest";

const ITEM_HEIGHT = 48;
const ITEM_PADDING_TOP = 8;
const MenuProps = {
  PaperProps: {
    sx: {
      maxHeight: ITEM_HEIGHT * 4.5 + ITEM_PADDING_TOP,
      "& .MuiList-root": {
        "& .MuiMenuItem-root": {
          fontWeight: "500",
          fontSize: "11px",
          color: "#525050",
        },
      },
    },
  },
};

const DashboardVideosFilterModal = (props) => {
  const countryNames = Object.values(countries.countries).map(
    (country) => country.name
  );
  // console.warn('countryNames', countryNames);
  // const {
  //   has_note,
  //   unreachable_submitter,
  //   hasMessage,
  //   month,
  //   year,
  //   submit_place,
  //   user_id,
  //   manager_id,
  //   quality_team_id,
  //   people_appearing,
  //   person_who_filmed,
  //   submit_other_website,
  //   aggrement_with_another_company,
  // } = useAppSelector((s) => s.dashboardApproveApproveSlice);

  const { acquisitors, managers, qualityTeam } = useAppSelector(
    (s) => s.appStateSlice
  );

  const {
    hideBottom,
    onClose,
    modalFields,
    approvedByColName,
    confirmedByColName,
    ...rest
  } = props;

  // console.warn("first", approvedByColName, confirmedByColName);

  const {
    has_note,
    unreachable_submitter,
    hasMessage,
    month,
    year,
    submit_place,
    user_id,
    manager_id,
    quality_team_id,
    people_appearing,
    person_who_filmed,
    submit_other_website,
    aggrement_with_another_company,
  } = props.states;
  const {
    setHasNote,
    setUnreachableSubmitter,
    setHasMessage,
    setMonth,
    setYear,
    setSubmitPlace,
    setUserId,
    setManagerId,
    setQualityTeamId,
    setPeopleAppearing,
    setPersonWhoFilmed,
    setSubmitOtherWebsite,
    setAgreementWithAnotherCompany,
  } = props.setStates;

  const dispatch = useAppDispatch();

  const handleClose = useCallback(
    (e, reason) => {
      onClose?.(e, reason || "backdropClick");
    },
    [onClose]
  );

  // console.warn('qualityTeam', qualityTeam)

  const [mockMonth, setMockMonth] = useState();
  const [mockUser, setMockUser] = useState();
  const [mockManager, setMockManager] = useState();
  const [mockQuality, setMockQuality] = useState();

  return (
    <Dialog
      className={`${styles.filterModal_parent} filterModal`}
      {...rest}
      onClose={handleClose}
    >
      <Box className={`${styles.filtermodalwraps} filterModalWrapper`}>
        <Box className="filterModalHeader">
          <h4>Filter</h4>
          <Button
            onClick={props?.handleClearFilterModal}
            className={styles.handlrclear}
          >
            <img src={assest.resetIcon} width={9} height={9} alt="" />
            <p>Clear</p>
          </Button>
        </Box>

        <Box className="filterModalBody">
          <Box className={`${styles.fltbodyboxes} filterBodyBox`}>
            <Box className={styles.filterboxnotes}>
              <Box
                className={`${styles.hasnotes} ${styles.gaptype1} filterBoxItem`}
              >
                <label className={styles.label_nm_cmn}>
                  Has Notes?{" "}
                  <img
                    src={assest.resetIconBlue}
                    className={styles.rested_blue}
                    width={9}
                    onClick={() => dispatch(setHasNote(null))}
                    height={9}
                    alt=""
                  />
                </label>
                <Box className="filterRadio">
                  <FormControl>
                    <RadioGroup
                      aria-labelledby="demo-radio-buttons-group-label"
                      // defaultValue={null}
                      value={has_note != null ? has_note : null}
                      name="has_note"
                      onChange={(e) => dispatch(setHasNote(e.target.value))}
                    >
                      <Box className="filterFromControl">
                        <FormControlLabel
                          value="yes"
                          control={<Radio />}
                          label="Yes"
                        />
                        <FormControlLabel
                          value="no"
                          control={<Radio />}
                          label="No"
                        />
                      </Box>
                    </RadioGroup>
                  </FormControl>
                </Box>
              </Box>

              <Box
                className={`${styles.unreach_submttr} ${styles.gaptype2} filterBoxItem`}
              >
                <label className={styles.label_nm_cmn}>
                  Unreachable Submitter?{" "}
                  <img
                    src={assest.resetIconBlue}
                    className={styles.rested_blue}
                    onClick={() => dispatch(setUnreachableSubmitter(null))}
                    width={9}
                    height={9}
                    alt=""
                  />
                </label>
                <Box className="filterRadio">
                  <FormControl>
                    <RadioGroup
                      aria-labelledby="demo-radio-buttons-group-label"
                      // defaultValue="female"
                      value={unreachable_submitter}
                      name="unreachable_submitter"
                      onChange={(e) =>
                        dispatch(setUnreachableSubmitter(e.target.value))
                      }
                    >
                      <Box className="filterFromControl">
                        <FormControlLabel
                          value="yes"
                          control={<Radio />}
                          label="Yes"
                        />
                        <FormControlLabel
                          value="no"
                          control={<Radio />}
                          label="No"
                        />
                      </Box>
                    </RadioGroup>
                  </FormControl>
                </Box>
              </Box>

              <Box
                className={`${styles.haspendingmsg}  ${styles.gaptype3} filterBoxItem`}
              >
                <label className={styles.label_nm_cmn}>
                  Has Pending Message{" "}
                  <img
                    src={assest.resetIconBlue}
                    className={styles.rested_blue}
                    onClick={() => dispatch(setHasMessage(null))}
                    width={9}
                    height={9}
                    alt=""
                  />
                </label>
                <Box className="filterRadio">
                  <FormControl>
                    <RadioGroup
                      aria-labelledby="demo-radio-buttons-group-label"
                      // defaultValue="female"
                      value={hasMessage}
                      name="has_message"
                      onChange={(e) => dispatch(setHasMessage(e.target.value))}
                    >
                      <Box className="filterFromControl">
                        <FormControlLabel
                          value="yes"
                          control={<Radio />}
                          label="Yes"
                        />
                        <FormControlLabel
                          value="no"
                          control={<Radio />}
                          label="No"
                        />
                      </Box>
                    </RadioGroup>
                  </FormControl>
                </Box>
              </Box>

              <Box
                className={`${styles.filmed_in} ${styles.gaptype1} filterBoxItem`}
              >
                <label className={styles.label_nm_cmn}>
                  Filmed in{" "}
                  <img
                    onClick={() => {
                      dispatch(setYear(null));
                      dispatch(setMonth(null));
                    }}
                    src={assest.resetIconBlue}
                    className={styles.rested_blue}
                    width={9}
                    height={9}
                    alt=""
                  />
                </label>
                <Box className="filterSelect filterSelectSmall">
                  <Select
                    labelId="month-label"
                    id="month-select"
                    displayEmpty
                    value={month}
                    className="month_box"
                    renderValue={() => {
                      // console.warn('selected', selected)
                      if (!month) {
                        return <span>Month</span>;
                      } else {
                        return <span>{mockMonth.month}</span>;
                      }
                    }}
                    MenuProps={MenuProps}
                    inputProps={{
                      "aria-label": "Without label",
                    }}
                    onChange={(e) => {
                      dispatch(setMonth(e.target.value.value));
                      setMockMonth(e.target.value);
                      // console.warn("e.target.value", e.target.value);
                    }}
                  >
                    {sampleMonthsValueArray.map((m, i) => (
                      <MenuItem key={i} value={m}>
                        {m.month}
                      </MenuItem>
                    ))}
                  </Select>
                  <Select
                    labelId="year-label"
                    id="year-select"
                    displayEmpty
                    value={year}
                    className="year_box"
                    renderValue={(selected) => {
                      // console.warn('selected', selected)
                      if (!selected) {
                        return <span>Year</span>;
                      } else {
                        return <span>{selected}</span>;
                      }
                    }}
                    MenuProps={MenuProps}
                    inputProps={{
                      "aria-label": "Without label",
                    }}
                    onChange={(e) => {
                      dispatch(setYear(e.target.value));
                      // console.warn("e.target.value", e.target.value);
                    }}
                  >
                    {sampleYearList.map((y, i) => (
                      <MenuItem key={i} value={y}>
                        {y}
                      </MenuItem>
                    ))}
                  </Select>
                </Box>
              </Box>

              <Box
                className={`${styles.filmlocator} ${styles.gaptype2} filterBoxItem`}
              >
                <label className={styles.label_nm_cmn}>
                  Filming Location{" "}
                  <img
                    onClick={() => dispatch(setSubmitPlace(null))}
                    src={assest.resetIconBlue}
                    className={styles.rested_blue}
                    width={9}
                    height={9}
                    alt=""
                  />
                </label>
                <Box className="filterSelect">
                  <Select
                    labelId="location-label"
                    id="location-select"
                    displayEmpty
                    value={submit_place}
                    renderValue={(selected) => {
                      // console.warn('selected', selected)
                      if (!selected) {
                        return <span>Location</span>;
                      } else {
                        return <span>{selected}</span>;
                      }
                    }}
                    MenuProps={MenuProps}
                    inputProps={{
                      "aria-label": "Without label",
                    }}
                    onChange={(e) => {
                      dispatch(setSubmitPlace(e.target.value));
                      // console.warn("e.target.value", e.target.value);
                    }}
                  >
                    {countryNames.map((p, i) => (
                      <MenuItem key={i} value={p}>
                        {truncateString(p, 20)}
                      </MenuItem>
                    ))}
                  </Select>
                </Box>
              </Box>

              <Box
                className={`${styles.acquistors_filter} ${styles.gaptype3} filterBoxItem`}
              >
                <label className={styles.label_nm_cmn}>
                  Acquisitor{" "}
                  <img
                    onClick={() => dispatch(setUserId(null))}
                    src={assest.resetIconBlue}
                    className={styles.rested_blue}
                    width={9}
                    height={9}
                    alt=""
                  />
                </label>
                <Box className="filterSelect">
                  <Select
                    labelId="user-label"
                    id="user-select"
                    displayEmpty
                    value={user_id}
                    renderValue={() => {
                      // console.warn('selected', selected)
                      if (!user_id) {
                        return <span>Acquisitor</span>;
                      } else {
                        return <span>{mockUser?.name}</span>;
                      }
                    }}
                    MenuProps={MenuProps}
                    inputProps={{
                      "aria-label": "Without label",
                    }}
                    onChange={(e) => {
                      dispatch(setUserId(e.target.value.id));
                      setMockUser(e.target.value);
                      // console.warn("e.target.value", e.target.value);
                    }}
                  >
                    {acquisitors?.map((a, i) => (
                      <MenuItem key={i} value={a}>
                        {a.name}
                      </MenuItem>
                    ))}
                  </Select>
                </Box>
              </Box>

              <Box className={`${styles.approve_by_sec} filterBoxItem`}>
                <label className={styles.label_nm_cmn}>
                  {approvedByColName}{" "}
                  <img
                    onClick={() => dispatch(setManagerId(null))}
                    src={assest.resetIconBlue}
                    className={styles.rested_blue}
                    width={9}
                    height={9}
                    alt=""
                  />
                </label>
                <Box className="filterSelect">
                  <Select
                    labelId="user-label"
                    id="user-select"
                    displayEmpty
                    value={manager_id}
                    renderValue={() => {
                      // console.warn('selected', selected)
                      if (!manager_id) {
                        return <span>{approvedByColName}</span>;
                      } else {
                        return <span>{mockManager?.name}</span>;
                      }
                    }}
                    MenuProps={MenuProps}
                    inputProps={{
                      "aria-label": "Without label",
                    }}
                    onChange={(e) => {
                      dispatch(setManagerId(e.target.value.id));
                      setMockManager(e.target.value);
                      // console.warn("e.target.value", e.target.value);
                    }}
                  >
                    {managers?.map((a, i) => (
                      <MenuItem key={i} value={a}>
                        {a.name}
                      </MenuItem>
                    ))}
                  </Select>
                </Box>
              </Box>

              <img
                src={assest.large_arrow_purple}
                width={53}
                height={2}
                alt=""
                className="purpleArrowIcon"
              />

              <Box className={`${styles.cnfrmby_sec} filterBoxItem`}>
                <label className={styles.label_nm_cmn}>
                  {confirmedByColName}{" "}
                  <img
                    onClick={() => dispatch(setQualityTeamId(null))}
                    src={assest.resetIconBlue}
                    className={styles.rested_blue}
                    width={9}
                    height={9}
                    alt=""
                  />
                </label>
                <Box className="filterSelect">
                  <Select
                    labelId="user-label"
                    id="user-select"
                    displayEmpty
                    value={quality_team_id}
                    renderValue={() => {
                      // console.warn('selected', selected)
                      if (!quality_team_id) {
                        return <span>{confirmedByColName}</span>;
                      } else {
                        return <span>{mockQuality?.name}</span>;
                      }
                    }}
                    MenuProps={MenuProps}
                    inputProps={{
                      "aria-label": "Without label",
                    }}
                    onChange={(e) => {
                      dispatch(setQualityTeamId(e.target.value.id));
                      setMockQuality(e.target.value);
                      // console.warn("e.target.value", e.target.value);
                    }}
                  >
                    {qualityTeam?.map((a, i) => (
                      <MenuItem key={i} value={a}>
                        {a.name}
                      </MenuItem>
                    ))}
                  </Select>
                </Box>
              </Box>
            </Box>

            {/* {hideBottom === true ? ( */}
            <Box
              className={`${styles.appear_people_videosc} filterBodyBox filterBodyBox2`}
            >
              <Box className="filterBoxItem">
                <label>
                  Are There People Appearing In The Video?
                  <img
                    src={assest.resetIconBlue}
                    className={styles.rested_blue}
                    width={9}
                    height={9}
                    alt=""
                    onClick={() => dispatch(setPeopleAppearing(null))}
                  />
                </label>

                <Box className="filterRadio">
                  <FormControl>
                    <RadioGroup
                      aria-labelledby="demo-radio-buttons-group-label"
                      // defaultValue="female"
                      value={people_appearing}
                      name="people_appearing"
                      onChange={(e) =>
                        dispatch(setPeopleAppearing(e.target.value))
                      }
                    >
                      <Box className="filterFromControl">
                        <FormControlLabel
                          value="yes"
                          control={<Radio />}
                          label="Yes"
                        />
                        <FormControlLabel
                          value="no"
                          control={<Radio />}
                          label="No"
                        />
                      </Box>
                    </RadioGroup>
                  </FormControl>
                </Box>
              </Box>

              <Box className="filterBoxItem">
                <label>
                  The Person Who Filmed This Video Is:{" "}
                  <img
                    src={assest.resetIconBlue}
                    className={styles.rested_blue}
                    onClick={() => dispatch(setPersonWhoFilmed(null))}
                    width={9}
                    height={9}
                    alt=""
                  />
                </label>

                <Box className="filterRadio">
                  <FormControl>
                    <RadioGroup
                      aria-labelledby="demo-radio-buttons-group-label"
                      // defaultValue="female"
                      // value={props?.modalFields?.person_who_filmed}
                      value={
                        person_who_filmed != null ? person_who_filmed : null
                      }
                      name="person_who_filmed"
                      // onChange={props?.handleFilterParamChange}
                      onChange={(e) =>
                        dispatch(setPersonWhoFilmed(e.target.value))
                      }
                    >
                      <Box className="filterFromControl">
                        <FormControlLabel
                          value="Me"
                          control={<Radio />}
                          label="Me"
                        />
                        <FormControlLabel
                          value="A Family Member"
                          control={<Radio />}
                          label="A Family Member"
                        />
                        <FormControlLabel
                          value="A Friend"
                          control={<Radio />}
                          label="A Friend"
                        />
                        <FormControlLabel
                          value="Someone I Know"
                          control={<Radio />}
                          label="Someone I Know"
                        />
                        <FormControlLabel
                          value="A Dashcam"
                          control={<Radio />}
                          label="A Dashcam"
                        />
                        <FormControlLabel
                          value="A Security Camera"
                          control={<Radio />}
                          label="A Security Camera"
                        />
                        <FormControlLabel
                          value="Other: the kid of my friend"
                          control={<Radio />}
                          label="Other: the kid of my friend"
                        />
                      </Box>
                    </RadioGroup>
                  </FormControl>
                </Box>
              </Box>

              <Box className="filterBoxItem">
                <label>
                  Did You Send/Submit/Upload This Video To A Website And/Or
                  Social Media Account?{" "}
                  <img
                    src={assest.resetIconBlue}
                    className={styles.rested_blue}
                    onClick={() => dispatch(setSubmitOtherWebsite(null))}
                    width={9}
                    height={9}
                    alt=""
                  />
                </label>

                <Box className="filterRadio">
                  <FormControl>
                    <RadioGroup
                      aria-labelledby="demo-radio-buttons-group-label"
                      // defaultValue="female"
                      value={
                        submit_other_website != null
                          ? submit_other_website
                          : null
                      }
                      // value={props?.modalFields?.submit_other_website}
                      name="submit_other_website"
                      // onChange={props?.handleFilterParamChange}
                      onChange={(e) =>
                        dispatch(setSubmitOtherWebsite(e.target.value))
                      }
                    >
                      <Box className="filterFromControl">
                        <FormControlLabel
                          value="No, I Did Not"
                          control={<Radio />}
                          label="No, I Did Not"
                        />
                        <FormControlLabel
                          value="Yes, Another Company's Website"
                          control={<Radio />}
                          label="Yes, Another Company's Website"
                        />
                        <FormControlLabel
                          value="Yes, A Facebook Page"
                          control={<Radio />}
                          label="Yes, A Facebook Page"
                        />
                        <FormControlLabel
                          value="Yes, A Twitter Account"
                          control={<Radio />}
                          label="Yes, A Twitter Account"
                        />
                        <FormControlLabel
                          value="Yes, An Instagram Account"
                          control={<Radio />}
                          label="Yes, An Instagram Account"
                        />
                        <FormControlLabel
                          value="Yes, A YouTube Channel"
                          control={<Radio />}
                          label="Yes, A YouTube Channel"
                        />
                        <FormControlLabel
                          value="Yes, A Snaphat Account"
                          control={<Radio />}
                          label="Yes, A Snaphat Account"
                        />
                      </Box>
                    </RadioGroup>
                  </FormControl>
                </Box>
              </Box>

              <Box className="filterBoxItem">
                <label>
                  Did You Sign A Licensing Agreement For This Video With Another
                  Company/Page?{" "}
                  <img
                    src={assest.resetIconBlue}
                    className={styles.rested_blue}
                    onClick={() =>
                      dispatch(setAgreementWithAnotherCompany(null))
                    }
                    width={9}
                    height={9}
                    alt=""
                  />
                </label>

                <Box className="filterRadio">
                  <FormControl>
                    <RadioGroup
                      aria-labelledby="demo-radio-buttons-group-label"
                      // defaultValue="female"
                      value={
                        aggrement_with_another_company != null
                          ? aggrement_with_another_company
                          : null
                      }
                      // value={
                      //   props?.modalFields?.aggrement_with_another_company
                      // }
                      name="aggrement_with_another_company"
                      // onChange={props?.handleFilterParamChange}
                      onChange={(e) =>
                        dispatch(setAgreementWithAnotherCompany(e.target.value))
                      }
                    >
                      <Box className="filterFromControl">
                        <FormControlLabel
                          value="No, I Did Not"
                          control={<Radio />}
                          label="No, I Did Not"
                        />
                        <FormControlLabel
                          value="Yes, I Have Filled An Online Not"
                          control={<Radio />}
                          label="Yes, I Have Filled An Online Not"
                        />
                        <FormControlLabel
                          value="Yes, I Have Signed An Exclusive Agreement"
                          control={<Radio />}
                          label="Yes, I Have Signed An Exclusive Agreement"
                        />
                        <FormControlLabel
                          value="Yes, I Have Signed A Non-Exclusive Agreement"
                          control={<Radio />}
                          label="Yes, I Have Signed A Non-Exclusive Agreement"
                        />
                      </Box>
                    </RadioGroup>
                  </FormControl>
                </Box>
              </Box>
            </Box>
            {/* ) : null} */}
          </Box>
        </Box>

        <Box className="filterModalFooter">
          <Box className="buttonGroup">
            <Button onClick={handleClose}>Cancel</Button>
            <Button
              className="activeButton activeButton_filter"
              type="submit"
              onClick={props?.filterRefetch}
            >
              Filter <span>now</span>
            </Button>
          </Box>
        </Box>
      </Box>
    </Dialog>
  );
};

export default DashboardVideosFilterModal;
